import { render, staticRenderFns } from "./AudioFilesSong.vue?vue&type=template&id=8cf9f5aa"
import script from "./AudioFilesSong.vue?vue&type=script&lang=js"
export * from "./AudioFilesSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports